import { useEffect, useRef, useState } from "react";
import { Fetch, hrLenseBaseUrl } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IUser, IUserStats } from "./modal";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import { getDialogTheme, getSuccessRate } from "./User";

export function UserInfo({ user, open, hideDialog }: { user: IUser, open: boolean, hideDialog: () => void }) {
    const toast = useRef<any>();

    const [stats, setStats] = useState<IUserStats>();
    const [loading, setLoading] = useState(false);

    const getUserStats = async (loginId: number) => {
        if (loading) return;
        setLoading(true);
        const response = await Fetch(`Experiment/jv-user-stats`, 'GET', null, `loginId=${loginId}`, toast);
        if (response) {
            const data = await response.json();
            setStats(data);
        }
        setLoading(false);
    }

    useEffect(() => {
        if (open && user.id) {
            getUserStats(user.id);
        }
    }, [user.id, open]);

    const themeColor = getDialogTheme(user, stats);

    return (
        <>
            <Dialog
                closable visible={open}
                headerStyle={{ background: themeColor.gradient, color: themeColor.text }}
                header={user.name} className="p-fluid"
                onHide={hideDialog}>
                <div style={{
                    display: "flex",
                    gap: 8, paddingTop: 16,
                }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: 6,
                        border: '1px solid #ccc',
                        position: 'relative',
                    }}>
                        <img src={user.employeeId ?
                            `${hrLenseBaseUrl}/Hrlense_Employee/getEmployeeImages?EmployeeCode=${user.employeeId}`
                            : '/img/user-icon.png'}
                            onError={e => e.currentTarget.src = '/img/user-icon.png'}
                            style={{ width: '320px', height: '320px', objectFit: 'contain', borderRadius: 6 }} loading="lazy" />
                        <Tag style={{ background: themeColor.gradient, color: themeColor.text, position: 'absolute', top: 0, left: 0 }} value={user.role}></Tag>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', marginTop: 8 }}>

                        <div >
                            <div style={styles.info}><b>Professional Email :</b> <span>{user.email}</span></div>
                            <div style={styles.info}><b>Company (Branch) :</b> <span>{user.companyName} ({user.branchName})</span></div>
                        </div>

                        {loading ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <i className="pi pi-spin pi-spinner"></i>
                            </div> :
                            <>{(user.role === 'Sales Manager' || user.role === 'Recruiter') &&
                                <div>
                                    {user.role === 'Sales Manager' && <div style={styles.info}><b style={styles.infoHead}>Requirement Success Rate (RSR) :</b> <span style={{ color: themeColor.dark, fontWeight: 800 }}>{stats ? getSuccessRate(stats.requirement, stats.po) : ''}</span></div>}
                                    {user.role === 'Recruiter' && <div style={styles.info}><b style={styles.infoHead}>Submission Success Rate (SSR) :</b> <span style={{ color: themeColor.dark, fontWeight: 800 }}>{stats ? getSuccessRate(stats.submission, stats.po) : ''}</span></div>}
                                    {user.role === 'Sales Manager' && <div style={styles.info}><b style={styles.infoHead}>Total Requirements :</b> <span style={styles.infoBody}>{stats?.requirement}</span></div>}
                                    {user.role === 'Recruiter' && <div style={styles.info}><b style={styles.infoHead}>Total Submissions :</b> <span style={styles.infoBody}>{stats?.submission}</span></div>}
                                    <div style={styles.info}><b style={styles.infoHead}>Total End Client Submissions (ECS) :</b> <span style={styles.infoBody}>{stats?.ecs}</span></div>
                                    <div style={styles.info}><b style={styles.infoHead}>Total End Client Interviews (ECI) :</b> <span style={styles.infoBody}>{stats?.eci}</span></div>
                                    <div style={styles.info}><b style={styles.infoHead}>Total Purchase Orders (PO) :</b> <span style={styles.infoBody}>{stats?.po}</span></div>
                                </div>}</>
                        }

                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 6, }}>
                            <Button onClick={hideDialog} className="p-button-sm p-button-secondary p-button-rounded" label="Close" />
                        </div>
                    </div>
                </div>
            </Dialog>
            <Toast ref={toast} />
        </>
    );
}


const styles: Record<string, React.CSSProperties> = {
    container: {
        display: "flex",
        alignItems: "center",
        gap: 5,
    },
    avatar: {
        width: 28,
        height: 28,
        borderRadius: "50%",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 400,
        position: 'relative',
        cursor: 'pointer',
    },
    avatarImg: {
        width: 28,
        height: 28,
        borderRadius: "50%",
        objectFit: "cover",
    },
    name: {
        fontSize: 12,
        fontWeight: 400
    },
    onlineDot: {
        position: "absolute",
        bottom: 1,
        right: 1,
        width: 7,
        height: 7,
        borderRadius: "50%",
        backgroundColor: "#22c55e",
        border: "1px solid white"
    },
    info: {
        fontWeight: 600,
        fontSize: 14,
        display: 'flex',
        justifyContent: 'space-between',
        padding: 2,
    },
};